import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, interval, Subscription, of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Tables } from '../../store/models/tables.model';

// Interface simplifiée pour les notifications serveur
interface ApiNotification {
  id: number;
  order_number: string;
  order_id: number;
  table: string;
  kitchen_name: string;
  kitchen_display_name: string;
  called_at: string;
  recalled_at: string | null;
  is_recall: boolean;
  time_ago: string;
  items_count: number;
  status: string;
}

export interface OrderNotification {
  id: number;
  orderNumber: string;
  orderId: number;
  table: string;
  kitchenName: string;
  kitchenDisplayName: string;
  calledAt: string;
  recalledAt: string | null;
  isRecall: boolean;
  timeAgo: string;
  itemsCount: number;
  callTime: string; // Heure extraite (HH:MM)
}

@Injectable({
  providedIn: 'root'
})
export class OrderNotificationService {
  private ordersToPickup = new BehaviorSubject<OrderNotification[]>([]);
  private trackedRecallDates: Map<number, string> = new Map();
  private recallCounts: Map<number, number> = new Map();
  private pollingSubscription: Subscription | null = null;
  private restaurantId: number = 2;
  private serverId: number | null = null;
  private tables: Map<string, string> = new Map();

  ordersToPickup$: Observable<OrderNotification[]> = this.ordersToPickup.asObservable();

  constructor(
   
    private http: HttpClient
  ) {}

  // Charger les tables (pour afficher le code de la table)
  private loadTables() {
    const url = `${environment.url}/tables/marrakech/data.json`;
    this.http.get<any>(url).subscribe({
      next: (response) => {
        const tablesArray = Array.isArray(response) ? response : response.data || [];
        tablesArray.forEach((table: Tables) => {
          if (table.id && table.code) this.tables.set(table.id.toString(), table.code);
        });
      },
      error: (err) => console.error('Erreur chargement tables:', err)
    });
  }

  // Démarrer le polling des notifications
  startPolling(restaurantId?: number, serverId?: number) {
    if (restaurantId) this.restaurantId = restaurantId;
    if (serverId) this.serverId = serverId;

    if (!this.serverId) {
      console.error('❌ serverId requis pour le polling');
      return;
    }

    this.loadTables();
    this.stopPolling(); // arrêter polling existant
    this.checkOrdersFromServerOnce();

    this.pollingSubscription = interval(5000).subscribe(() => {
      this.checkOrdersFromServerOnce();
    });
  }

  stopPolling() {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
      this.pollingSubscription = null;
    }
  }

  // Vérification ponctuelle (utilisée depuis AppComponent quand push reçue)
  checkOrdersFromServerOnce() {
    this.getOrdersFromServer().subscribe(notifications => {
      this.checkOrderNotifications(notifications);
    });
  }

  private getOrdersFromServer(): Observable<OrderNotification[]> {
    return of([]);

    
  }

  private checkOrderNotifications(notifications: OrderNotification[]) {
    let shouldPlaySound = false;

    notifications.forEach(notification => {
      const notifId = notification.id;
      const dateStr = notification.recalledAt || notification.calledAt;
      const lastDate = this.trackedRecallDates.get(notifId);

      if (!lastDate || lastDate !== dateStr) {
        this.trackedRecallDates.set(notifId, dateStr);

        if (notification.isRecall) {
          const currentCount = this.recallCounts.get(notifId) || 0;
          this.recallCounts.set(notifId, currentCount + 1);
        } else {
          this.recallCounts.set(notifId, 0);
        }

        shouldPlaySound = true;
      }
    });

    this.ordersToPickup.next(notifications);

   

  }


  clearAllOrders() {
    this.trackedRecallDates.clear();
    this.recallCounts.clear();
    this.ordersToPickup.next([]);
    this.stopPolling();
  }

  private extractDateString(dateValue: any): string {
    if (!dateValue) return '';
    if (typeof dateValue === 'string') return dateValue;
    if (typeof dateValue === 'object' && dateValue.date) return dateValue.date;
    return '';
  }

  private extractTimeFromDate(dateValue: any): string {
    const dateStr = this.extractDateString(dateValue);
    if (!dateStr) return '';
    const timePart = dateStr.split(' ')[1];
    return timePart ? timePart.substring(0, 5) : '';
  }
}
